export function DateRangeFilter({ value, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="date"
        className="px-3 py-2.5 bg-white rounded-lg text-sm border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent"
        value={value.start || ""}
        onChange={(e) => onChange({ ...value, start: e.target.value })}
      />
      <span className="text-gray-500 text-sm">to</span>
      <input
        type="date"
        className="px-3 py-2.5 bg-white rounded-lg text-sm border border-gray-200 focus:ring-2 focus:ring-primary focus:border-transparent"
        value={value.end || ""}
        onChange={(e) => onChange({ ...value, end: e.target.value })}
      />
    </div>
  );
}
